import { type BidLoadStop, type BidLoad } from '../../domain/Bid'

export type RawBidLoadStop = {
  stop_index?: number
  type?: string
  city?: string
  state?: string
  country?: string
  zipcode?: string
  timezone?: string
  window_start?: string
  window_end?: string
  distance_from_previous_stop?: number
  facility_id?: string
  latitude?: number
  longitude?: number
  requirements?: string[]
  tags?: string[]
}

type RawBidLoadDimensions = {
  length: number | null
  height: number | null
  width: number | null
}

type RawBidLoadRequirements = {
  tsa?: boolean | null
  beer?: boolean | null
  hvhr?: boolean | null
  twic?: boolean | null
  tarp?: boolean | null
  ctpat?: boolean | null
  teams?: boolean | null
  frozen?: boolean | null
  hazmat?: boolean | null
  dunnage?: boolean | null
  produce?: boolean | null
  chemicals?: boolean | null
  food_grade?: boolean | null
  vented_vans?: boolean | null
  drop_trailer?: boolean | null
  pharmaceuticals?: boolean | null
  dont_call_driver?: boolean | null
}

export type RawBidLoad = {
  uuid?: string
  created_at?: string
  ref_number?: string
  direct_from_shipper?: boolean
  load_candidate?: boolean
  shipper_id?: string
  commodity?: string
  temperature?: number | null
  weight?: number
  mileage?: string
  customer_requirements?: string[]
  equipment_type?: string
  intermodal?: boolean | null
  stops?: RawBidLoadStop[]
  team_driver?: boolean
  dimensions?: RawBidLoadDimensions
  requirements?: RawBidLoadRequirements
  equipment_subtypes?: string[]
  shipper_market?: string
  tags?: string[]
  deadhead?: string | null
  mode?: string
  must_arrive_by_date?: string | null
}

export function mapBidLoadStop(stop: RawBidLoadStop): BidLoadStop {
  return {
    stopIndex: stop?.stop_index,
    type: stop?.type,
    city: stop?.city,
    state: stop?.state,
    country: stop?.country,
    zipcode: stop?.zipcode,
    timezone: stop?.timezone,
    windowStart: stop?.window_start ? new Date(stop?.window_start) : undefined,
    windowEnd: stop?.window_end ? new Date(stop?.window_end) : undefined,
    distanceFromPreviousStop: stop?.distance_from_previous_stop,
    facilityId: stop?.facility_id,
    latitude: stop?.latitude,
    longitude: stop?.longitude,
    requirements: stop?.requirements,
    tags: stop?.tags,
  }
}

export function mapApiToBidLoad(bidLoad: RawBidLoad): BidLoad {
  return {
    stops: (bidLoad.stops ?? []).map(mapBidLoadStop),
  }
}
